import { useEffect } from 'react'

import { Button, Typography } from '@tino-frontend/coreui'
import { Markdown } from '@tino-frontend/markdown'
import { NotificationActivePictogramPictogram } from '@tino-frontend/icons'

import { Float } from 'layouts/container'

import { useRegisterToken } from 'modules/notification'
import { useTexts } from './register-token.texts'
import { useAnalyticsSupplier } from 'modules/analytics'
import { EventNames, Platforms, Scopes } from 'constants/events/mixpanel'

function RegisterTokenContainer() {
  const texts = useTexts()
  const { open, submit, listener, setOpen } = useRegisterToken()
  const sendEvent = useAnalyticsSupplier()

  useEffect(() => {
    listener()
  }, [])

  useEffect(() => {
    if (open) {
      sendEvent({
        eventName: EventNames.ModalNotificationViewed,
        scope: Scopes.ModalNotification,
        platform: Platforms.SalespersonApp,
      })
    }
  }, [open])

  function handleSubmit(accepted: boolean) {
    return () => {
      if (accepted) {
        sendEvent({
          eventName: EventNames.SendNotificationButtonClicked,
          scope: Scopes.ModalNotification,
          platform: Platforms.SalespersonApp,
          allowed: true,
        })

        sendEvent({
          eventName: EventNames.ModalNotificationNotificationSent,
          scope: Scopes.ModalNotification,
          platform: Platforms.SalespersonApp,
          allowed: true,
        })
      }
      submit(accepted)
    }
  }

  function handleClose() {
    setOpen(false)

    sendEvent({
      eventName: EventNames.ModalNotificationBackButtonClicked,
      scope: Scopes.ModalNotification,
      platform: Platforms.SalespersonApp,
      not_allowed: true,
    })
  }

  return (
    <Float maxWidth="xs" open={open} onChange={handleClose}>
      <NotificationActivePictogramPictogram fontSize={4} />

      <Markdown
        mt={5}
        paragraph={{
          variant: 'h4',
          fontWeight: 'light',
        }}
        sx={{
          strong: {
            color: 'text.high',
            fontWeight: 'normal',
          },
        }}
      >
        {texts.title}
      </Markdown>

      <Typography variant="body2" mt={3} mb={5}>
        {texts.description}
      </Typography>

      <Button
        size="large"
        color="primary"
        variant="contained"
        data-testid="submit"
        fullWidth
        onClick={handleSubmit(true)}
      >
        {texts.submit}
      </Button>
    </Float>
  )
}

export default RegisterTokenContainer
